import { SessionSearches } from '../types';

export const validateHasAllSearchResults = (sessionSearches: SessionSearches) =>
  Object.entries(sessionSearches)
    .map(([_key, search]) => search.elapsed)
    .every((elapsed) => elapsed !== undefined);
